module.exports = __webpack_public_path__ + "img/logo_dp.c8372d30.png";